import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import "chart.js/auto";
import { Bar, Pie } from "react-chartjs-2";
import { PaginationControl } from "react-bootstrap-pagination-control";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Select from "react-select";
import ManualBarChart2 from "./manualbarchart2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const DashboardBankKalteng = () => {
  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingChart, setLoadingChart] = useState(false);
  const [info, setInfo] = useState("");
  const [totalDataResponden, setTotalDataResponden] = useState(0);
  const [totalDataSelesai, setTotalDataSelesai] = useState(0);
  const [totalDataDalamProses, setTotalDataDalamProses] = useState(0);
  const [totalDataBelumMulai, setTotalDataBelumMulai] = useState(0);
  const [current, setCurrent] = useState(1);
  const [responden, setResponden] = useState([""]);
  const [selesai, setSelesai] = useState([""]);
  const [dalamProses, setDalamProses] = useState([""]);
  const [belumMulai, setBelumMulai] = useState([""]);
  const [companyList, setCompanyList] = useState([""]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [type, setType] = useState("");
  const [pieChart, setPieChart] = useState("");
  const [barChart, setBarChart] = useState("");
  const [scatter, setScatter] = useState("");
  const [mind, setMind] = useState("");
  const [heart, setHeart] = useState("");
  const [soul, setSoul] = useState("");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [departments, setDepartments] = useState([]);
  const [workUnits, setWorkUnits] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedWorkUnit, setSelectedWorkUnit] = useState("");
  const { id } = useParams();
  const [chartData, setChartData] = useState([]);

  const dataType =
    type === "responden"
      ? responden
      : type === "mulai"
        ? belumMulai
        : type === "proses"
          ? dalamProses
          : selesai;

  const getDataResponden = (pageSize, pageIndex, searchIndex, department, workUnit) => {
    setLoading(true);
    return axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 15,
          search: searchIndex,
          limit: pageSize ?? 10,
          page: pageIndex ?? 1,
          department: department || "",
          attribute_6: workUnit || "",
        },
      })
      .then((res) => {
        const data = res.data.data || [];
        setResponden(data);
        setTotalDataResponden(res.data.totaldata);
        setLoading(false);
        return res.data.totaldata; // Return totaldata so you can use it later
      })
      .catch((error) => {
        console.error("Error fetching responden data:", error);
        setLoading(false);
      });
  };

  const getDataSelesai = (pageSize, pageIndex, searchIndex, department, workUnit) => {
    return axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 16,
          search: searchIndex,
          limit: pageSize ?? 10,
          page: pageIndex ?? 1,
          department: department || "",
          attribute_6: workUnit || "",
        },
      })
      .then((res) => {
        const data = res.data == 0 ? [] : res.data.data;
        setSelesai(data);
        setTotalDataSelesai(res.data.totaldata);
        setLoading(false);
        return res.data.totaldata;
      })
      .catch((error) => {
        console.error("Error fetching selesai data:", error);
        setLoading(false);
      });
  };

  const getDataDalamProses = (pageSize, pageIndex, searchIndex, department, workUnit) => {
    return axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 17,
          search: searchIndex,
          limit: pageSize ?? 10,
          page: pageIndex ?? 1,
          department: department || "",
          attribute_6: workUnit || "",
        },
      })
      .then((res) => {
        const data = res.data == 0 ? [] : res.data.data;
        setDalamProses(data);
        setTotalDataDalamProses(res.data.totaldata);
        setLoading(false);
        return res.data.totaldata;
      })
      .catch((error) => {
        console.error("Error fetching dalam proses data:", error);
        setLoading(false);
      });
  };

  const getDataBelumMulai = (pageSize, pageIndex, searchIndex, department, workUnit) => {
    return axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 18,
          search: searchIndex,
          limit: pageSize ?? 10,
          page: pageIndex ?? 1,
          department: department || "",
          attribute_6: workUnit || "",
        },
      })
      .then((res) => {
        const data = res.data == 0 ? [] : res.data.data;
        setBelumMulai(data);
        setTotalDataBelumMulai(res.data.totaldata);
        setLoading(false);
        return res.data.totaldata;
      })
      .catch((error) => {
        console.error("Error fetching belum mulai data:", error);
        setLoading(false);
      });
  };

  const updatePieChartData = (department, workUnit) => {
    setLoading(true);

    // Fetch all the necessary data
    Promise.all([
      getDataSelesai(10, 1, "", department, workUnit),
      getDataDalamProses(10, 1, "", department, workUnit),
      getDataBelumMulai(10, 1, "", department, workUnit),
    ])
      .then(([selesai, proses, belumMulai]) => {
        const newChartData = {
          label: ["Selesai", "Dalam Proses", "Belum Mulai"],
          data: [selesai || 0, proses || 0, belumMulai || 0],
        };

        setPieChart(newChartData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error updating pie chart data:", error);
        setLoading(false);
      });
  };


  const handleDepartmentChange = (selectedValue) => {
    const department = selectedValue || "";
    setSelectedDepartment(department);

    getDataResponden(10, 1, "", department, selectedWorkUnit).then((total) => {
      setInfo((prev) => ({ ...prev, total }));
    });

    getDataSelesai(10, 1, "", department, selectedWorkUnit).then((finish) => {
      setInfo((prev) => ({ ...prev, finish }));
    });

    getDataDalamProses(10, 1, "", department, selectedWorkUnit).then((progress) => {
      setInfo((prev) => ({ ...prev, progress }));
    });

    getDataBelumMulai(10, 1, "", department, selectedWorkUnit).then((not_started) => {
      setInfo((prev) => ({ ...prev, not_started }));
    });

    updatePieChartData(department, selectedWorkUnit);
  };

  const handleWorkUnitChange = (selectedValue) => {
    const workUnit = selectedValue || "";
    setSelectedWorkUnit(workUnit);

    getDataResponden(10, 1, "", selectedDepartment, workUnit).then((total) => {
      setInfo((prev) => ({ ...prev, total }));
    });

    getDataSelesai(10, 1, "", selectedDepartment, workUnit).then((finish) => {
      setInfo((prev) => ({ ...prev, finish }));
    });

    getDataDalamProses(10, 1, "", selectedDepartment, workUnit).then((progress) => {
      setInfo((prev) => ({ ...prev, progress }));
    });

    getDataBelumMulai(10, 1, "", selectedDepartment, workUnit).then((not_started) => {
      setInfo((prev) => ({ ...prev, not_started }));
    });

    updatePieChartData(selectedDepartment, workUnit);
  };



  const handleSearch = () => {
    if (type === "mulai") {
      getDataBelumMulai(10, 1, searchInput, selectedDepartment, selectedWorkUnit);
    } else if (type === "responden") {
      getDataResponden(10, 1, searchInput, selectedDepartment, selectedWorkUnit);
    } else if (type === "proses") {
      getDataDalamProses(10, 1, searchInput, selectedDepartment, selectedWorkUnit);
    } else {
      getDataSelesai(10, 1, searchInput, selectedDepartment, selectedWorkUnit);
    }
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 1,
        },
      })
      .then((res) => {
        setInfo(res.data);
        setLoading(false);
      });
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 8,
        },
      })
      .then((res) => {
        setCompanyList(res.data);
        setLoading(false);
      });
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 20,
        },
      })
      .then((res) => {
        setBarChart(res.data);
        setLoading(false);
      });
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: {
          id_survey: id,
          sel: 22,
        },
      })
      .then((res) => {
        setPieChart(res.data);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: { id_survey: id, sel: 28 },
      })
      .then((res) => {
        setDepartments(res.data);
      })
      .catch((error) => console.error("Error fetching departments:", error));
  }, [id]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: { id_survey: id, sel: 35},
      })
      .then((res) => {
        setWorkUnits(res.data);
      })
      .catch((error) => console.error("Error fetching workunits:", error));
  }, [id]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}`, {
        params: { id_survey: id, sel: 36 },
      })
      .then((res) => {
        setChartData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching chart data:", err);
      });
  }, [id]);

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData, fileName);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
    setLoadingButton(false);
  };

  const handleExport = () => {
    setLoadingButton(true);
    if (type === "responden") {
      axios
        .get(`${process.env.REACT_APP_URL}`, {
          params: {
            id_survey: id,
            sel: 15,
            search: "",
            limit: totalDataResponden,
            page: 1,
            department: selectedDepartment || "",
            workUnit: selectedWorkUnit || "",
          },
        })
        .then((res) => {
          const fileExport = res?.data?.data?.map((item) => ({
            name: item.firstname,
            jabatan: item.lastname,
            email: item.email,
            relationship: item.attribute_2,
            ratee: item.attribute_7,
            completed: item.completed,
            status: item.status
          }));
          exportToCSV(fileExport, "data-responden");
        });
    } else if (type === "mulai") {
      axios
        .get(`${process.env.REACT_APP_URL}`, {
          params: {
            id_survey: id,
            sel: 18,
            search: "",
            limit: totalDataBelumMulai,
            page: 1,
            department: selectedDepartment || "",
            workUnit: selectedWorkUnit || "",
          },
        })
        .then((res) => {
          const fileExport = res?.data?.data?.map((item) => ({
            name: item.firstname,
            status: item.status,
            cabang: item.lastname,
            email: item.email,
            completed: item.completed
          }));
          exportToCSV(fileExport, "data-belum-mulai");
        });
    } else if (type === "proses") {
      axios
        .get(`${process.env.REACT_APP_URL}`, {
          params: {
            id_survey: id,
            sel: 17,
            search: "",
            limit: totalDataDalamProses,
            page: 1,
            department: selectedDepartment || "",
            workUnit: selectedWorkUnit || "",
          },
        })
        .then((res) => {
          const fileExport = res?.data?.data?.map((item) => ({
            name: item.firstname,
            status: item.status,
            cabang: item.lastname,
            email: item.email,
            completed: item.completed
          }));
          exportToCSV(fileExport, "data-dalam-proses");
        });
    } else {
      axios
        .get(`${process.env.REACT_APP_URL}`, {
          params: {
            id_survey: id,
            sel: 16,
            search: "",
            limit: totalDataSelesai,
            page: 1,
            department: selectedDepartment || "",
            workUnit: selectedWorkUnit || "",
          },
        })
        .then((res) => {
          const fileExport = res?.data?.data?.map((item) => ({
            name: item.firstname,
            status: item.status,
            cabang: item.lastname,
            email: item.email,
            completed: item.completed
          }));
          exportToCSV(fileExport, "data-selesai");
        });
    }
  };

  const dataPie = {
    labels: pieChart.label,
    datasets: [
      {
        backgroundColor: ["#B2E672", "#FFFD88", "#FF8C8C"],
        hoverBackgroundColor: ["#B6E2A1", "#FFFBC1", "#F7A4A4"],
        data: pieChart.data,
      },
    ],
  };

  return (
    <>
      {loading === true ? (
        <div className="text-center p-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <div>
          <div className="col-xl-12 col-md-6 p-3">
            <div className="card border-left-presentase shadow h-100 py-2">
              <div className="card-body">
                <div className="row no-gutters align-items-center">
                  <div className="col">
                    <div className="text-xs fw-bold text-uppercase mb-1">
                      Persentase Penyelesaian
                    </div>
                    <div className="d-flex justify-content-start">
                      <div className="h5 mb-0 fw-bold text-secondary">
                        {info.percentage}%
                      </div>
                      <div class="progress w-100 mt-1 ms-2">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          style={{
                            width: `${info.percentage}%`,
                            backgroundColor: "#0E8388",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-auto">
                    <i class="fas fa-tasks fa-2x text-gray-300"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row px-3">
            <div className="col-xl-3 col-md-6 mb-4">
              <div
                className="card border-left-responden shadow h-100 py-2 pointer"
                onClick={() => (
                  setType("responden"),
                  setCurrent(1),
                  getDataResponden(10, 1, "", selectedDepartment, selectedWorkUnit),
                  setLoading(true)
                )}
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col">
                      <div className="text-xs fw-bold text-uppercase mb-1">
                        Total Responden
                      </div>
                      <div className="h5 mb-0 fw-bold text-secondary">
                        {info.total}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i class="fas fa-users fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 mb-4">
              <div
                className="card border-left-selesai shadow h-100 py-2 pointer"
                onClick={() => (
                  setType("selesai"),
                  setCurrent(1),
                  getDataSelesai(10, 1, search, selectedDepartment, selectedWorkUnit),
                  setLoading(true)
                )}
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col">
                      <div className="text-xs fw-bold text-uppercase mb-1">
                        Total Selesai
                      </div>
                      <div className="h5 mb-0 fw-bold text-secondary">
                        {info.finish}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i class="fas fa-check fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 mb-4">
              <div
                className="card border-left-proses shadow h-100 py-2 pointer"
                onClick={() => (
                  setType("proses"),
                  setCurrent(1),
                  getDataDalamProses(10, 1, search, selectedDepartment, selectedWorkUnit),
                  setLoading(true)
                )}
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col">
                      <div className="text-xs fw-bold text-uppercase mb-1">
                        Total Dalam Proses
                      </div>
                      <div className="h5 mb-0 fw-bold text-secondary">
                        {info.progress}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i class="fas fa-edit fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 mb-4">
              <div
                className="card border-left-mulai shadow h-100 py-2 pointer"
                onClick={() => (
                  setType("mulai"),
                  setCurrent(1),
                  getDataBelumMulai(10, 1, search, selectedDepartment, selectedWorkUnit),
                  setLoading(true)
                )}
              >
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col">
                      <div className="text-xs fw-bold text-uppercase mb-1">
                        Total Belum Mulai
                      </div>
                      <div className="h5 mb-0 fw-bold text-secondary">
                        {info.not_started}
                      </div>
                    </div>
                    <div className="col-auto">
                      <i class="fas fa-times fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div className="row mx-3">
              <div className="col-md-6 h-100">
                <div className=" card shadow " >
                  <div className=" card-body  d-flex justify-content-center" style={{ alignItems: "anchor-center" }}>
                    <Pie data={dataPie} className="pie-chart my-auto" />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className=" card shadow " >
                  <div className=" card-body  d-flex justify-content-center" style={{ alignItems: "anchor-center" }}>
                    <ManualBarChart2 data={chartData} />
                  </div>
                </div>
              </div>
            </div>

          {type ? (

            <div className="card border-0 py-2 mx-3 shadow-lg my-3">
              <div className="row px-3 mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Select Department</label>
                    <Select
                      className="mb-3"
                      placeholder="Select Department..."
                      isClearable
                      value={
                        selectedDepartment
                          ? { value: selectedDepartment, label: selectedDepartment }
                          : { value: "", label: "All Departments" }
                      }
                      options={[
                        { value: "", label: "All Departments" },
                        ...departments.map((dept) => ({
                          value: dept.value,
                          label: dept.value,
                        })),
                      ]}
                      onChange={(selectedOption) =>
                        handleDepartmentChange(selectedOption ? selectedOption.value : "")
                      }
                    />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold">Select Divisi</label>
                    <Select
                      className="mb-3"
                      placeholder="Select WorkUnit..."
                      isClearable
                      value={
                        selectedWorkUnit
                          ? { value: selectedWorkUnit, label: selectedWorkUnit }
                          : { value: "", label: "All Divisi" }
                      }
                      options={[
                        { value: "", label: "All Divisi" },
                        ...workUnits.map((work) => ({
                          value: work.value,
                          label: work.value,
                        })),
                      ]}
                      onChange={(selectedOption) =>
                        handleWorkUnitChange(selectedOption ? selectedOption.value : "")
                      }
                    />
                </div>
              </div>
              <div className="card-body">
                <p className="text-blue fw-bold">
                  Data{" "}
                  {type === "mulai"
                    ? "Belum Mulai"
                    : type === "responden"
                      ? "Responden"
                      : type === "proses"
                        ? "Dalam Proses"
                        : "Selesai"}
                </p>
                <div className="d-flex justify-content-between">
                  <div className="input-group w-75">
                    <input
                      className="form-control border"
                      placeholder="Search"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                    <button className="btn btn-outline-secondary" onClick={handleSearch}>
                      <i className="fas fa-search text-secondary"></i>
                    </button>
                  </div>
                  <button
                    className="btn bg-blue text-white px-3 ms-2"
                    onClick={handleExport}
                  >
                    {loadingButton === true ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Export Excel"
                    )}
                  </button>
                </div>
                <div className="table-responsive" style={{ overflowX: "auto", maxWidth: "100%" }}>
  <table className="table table-striped table-light mt-3 rounded rounded-3">
    <thead>
      <tr className="text-left bg-success">
        <th scope="col">No</th>
        <th scope="col">Name</th>
        <th scope="col">Jabatan</th>
        <th scope="col">Divisi</th>
        <th scope="col">Email</th>
        <th scope="col">Completed</th>
        <th scope="col">Status</th>
      </tr>
    </thead>
    <tbody>
      {dataType.map((item, index) => (
        <tr key={index}>
          <th className="fw-normal">
            {(current - 1) * 10 + (index + 1)}
          </th>
          <th className="fw-normal">{item.firstname}</th>
          <th className="fw-normal">{item.lastname}</th>
          <th className="fw-normal">{item.attribute_6}</th>
          <th className="fw-normal">{item.email}</th>
          <th className="fw-normal">{item.completed}</th>
          <th className="fw-normal">{item.status}</th>
        </tr>
      ))}
    </tbody>
  </table>
</div>

                <PaginationControl
                  page={current}
                  total={
                    type === "responden"
                      ? totalDataResponden
                      : type === "mulai"
                        ? totalDataBelumMulai
                        : type === "proses"
                          ? totalDataDalamProses
                          : totalDataSelesai
                  }
                  limit={10}
                  changePage={(page, size) => {
                    type === "mulai"
                      ? getDataBelumMulai(size, page, search, selectedDepartment, selectedWorkUnit)
                      : type === "responden"
                        ? getDataResponden(size, page, search, selectedDepartment, selectedWorkUnit)
                        : type === "proses"
                          ? getDataDalamProses(size, page, search, selectedDepartment, selectedWorkUnit)
                          : getDataSelesai(size, page, search, selectedDepartment, selectedWorkUnit);
                    setCurrent(page);
                  }}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default DashboardBankKalteng;
